module.exports = __webpack_public_path__ + "img/title.9fba7f60.png";